import React, { Fragment } from 'react';
import { setPaypalError } from 'State/Checkout';
import { PayPalButton } from 'Components/PayPal/PayPalButton';
import { PAYMENT_METHODS } from 'Features/PaymentMethodSelector/PaymentMethodSelector';
import { usePayPal } from 'Hooks/usePayPal';
import { showOverlay } from 'State/Layout';
import { useStore } from 'Hooks/useStore';

export const PayPalSelector = ({ handlePayment, submitButtonText, idName }) => {
  const { hasPaypalPayment } = useStore('paymentMethods');
  const [isPayPalEnabled, paypalActions] = usePayPal();

  if (!isPayPalEnabled) {
    return null;
  }
  // For saved payments we do not want to render another button so return null
  return (
    <Fragment>
      {hasPaypalPayment ? null : (
        <div className="paypalPaymentMethod">
          <PayPalButton
            submitButtonText={submitButtonText}
            onClick={() => paypalActions.createSubscriptionOrder()}
            idName={idName}
            onApprove={(data) => {
              showOverlay('', true);
              return handlePayment('paypal', data, PAYMENT_METHODS.PAYPAL);
            }}
            onError={(error) => setPaypalError(error.message)}
          />
        </div>
      )}
    </Fragment>
  );
};
